import React from "react";
import { Card, Row, Col, Statistic, Skeleton, Alert } from "antd";
import {
  FileTextOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  DollarCircleOutlined,
  LockOutlined,
  FileSearchOutlined,
  FileSyncOutlined
} from "@ant-design/icons";

const VoucherStatistics = ({ loading, statistics, error }) => {
  if (error) {
    return (
      <Alert
        message="Error Loading Statistics"
        description={error}
        type="error"
        showIcon
        style={{ marginBottom: 20 }}
      />
    );
  }

  const statisticsData = [
    {
      title: "Total Vouchers",
      value: statistics?.totalVouchersCreated || 0,
      icon: <FileTextOutlined />,
      color: "#1890ff",
      span: 6
    },
    {
      title: "Approved",
      value: statistics?.vouchersApproved || 0,
      icon: <CheckCircleOutlined />,
      color: "#52c41a",
      span: 6
    },
    {
      title: "Pending",
      value: statistics?.vouchersPending || 0,
      icon: <ClockCircleOutlined />,
      color: "#faad14",
      span: 6
    },
    {
      title: "Awaiting Check",
      value: statistics?.vouchersAwaitingChecking || 0,
      icon: <FileSearchOutlined />,
      color: "#13c2c2",
      span: 6
    },
    {
      title: "Rejected",
      value: statistics?.vouchersRejected || 0,
      icon: <CloseCircleOutlined />,
      color: "#f5222d",
      span: 6
    },
    {
      title: "Settled",
      value: statistics?.vouchersSettled || 0,
      icon: <DollarCircleOutlined />,
      color: "#52c41a",
      span: 6
    },
    {
      title: "Closed",
      value: statistics?.vouchersClosed || 0,
      icon: <LockOutlined />,
      color: "#722ed1",
      span: 6
    },
    {
      title: "Memos Awaiting Voucher",
      value: statistics?.memosAwaitingVoucherCreation || 0,
      icon: <FileSyncOutlined />,
      color: "#eb2f96",
      span: 6
    }
  ];

  return (
    <Card
      title="Voucher Statistics"
      style={{ marginBottom: 20 }}
      bodyStyle={{ padding: "20px" }}
    >
      {loading ? (
        <Row gutter={[16, 16]}>
          {[...Array(8)].map((_, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <Card>
                <Skeleton active paragraph={{ rows: 2 }} />
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <Row gutter={[16, 16]}>
          {statisticsData.map((stat, index) => (
            <Col xs={24} sm={12} md={8} lg={stat.span} key={index}>
              <Card hoverable>
                <Statistic
                  title={
                    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ color: stat.color, fontSize: 20 }}>
                        {stat.icon}
                      </span>
                      <span style={{ fontSize: 14, fontWeight: 500 }}>
                        {stat.title}
                      </span>
                    </span>
                  }
                  value={stat.value}
                  valueStyle={{ color: stat.color, fontSize: 24 }}
                />
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Card>
  );
};

export default VoucherStatistics;